import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { useStyles } from '../../theme/styles.helpers';
import { Orders } from '@hellohair/types';
import { useTranslation } from 'react-i18next';
import { SurveyStyles } from './Survey.Styles';

type Props = {
  images: Orders.SurveyAsset[];
};

const SurveyImageUploads = ({ images }: Props) => {
  const styles = useStyles(SurveyStyles, {});
  const [selectedImage, setSelectedImage] = useState<number>(0);
  const [loadingImage, setLoadingImage] = useState<boolean>(true);
  const { t } = useTranslation();

  if (!images.length) return null;

  return (
    <Box>
      <Typography variant="h5" marginY={3}>
        {t('Uploads')}
      </Typography>

      <Box>
        <Box sx={styles.previewImageWrapper}>
          {loadingImage && (
            <Box sx={styles.imageLoadingWrapper}>
              <Typography>loading...</Typography>
            </Box>
          )}

          <img
            alt={'Preview image'}
            width={'auto'}
            height={'100%'}
            src={images[selectedImage].signedUrl}
            // onClick={() => {
            //   window.open(images[selectedImage].signedUrl, '_blank');
            // }}
            onLoad={() => {
              setLoadingImage(false);
            }}
            onError={() => {
              setLoadingImage(false);
            }}
          />
        </Box>

        <Box sx={styles.thumbnailsWrapper}>
          {images.map((img, idx) => {
            if (!img.thumbnail) return null;
            return (
              <Box
                key={idx}
                height={'90px'}
                display={'flex'}
                onClick={() => {
                  if (selectedImage === idx) return;
                  setSelectedImage(idx);
                  setLoadingImage(true);
                }}
                sx={{
                  cursor: 'pointer',
                  background: `url(${img.thumbnail}) no-repeat center center / cover`,
                }}
                border={`2px solid ${selectedImage === idx ? 'black' : 'transparent'}`}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default SurveyImageUploads;
